import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import ReportHeader from '../../../../public/Images/ReportHeader.png';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';

export interface ReportTemplateProps {
  pageTitle: string | React.JSX.Element;
  body: React.JSX.Element;
}

const ReportsTemplate: React.FC<ReportTemplateProps> = ({
  pageTitle,
  body,
}) => {
  const useStyles = makeStyles()({
    slideSection: {
      display: 'flex !important',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: '#fff',
    },
    image: {
      position: 'absolute',
      top: '0',
      left: '0',
      zIndex: 1,
      maxWidth: '100% !important',
      height: 'auto',
      margin: '0px !important',
    },
    main: {
      padding: '1rem',
      margin: '-1rem 0',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
  });
  const { classes } = useStyles();
  return (
    <section className={classes.slideSection}>
      <img src={ReportHeader} alt="DataBarActive" className={classes.image} />
      {typeof pageTitle === 'string' ? (
        <Typography
          fontSize="36px"
          fontType="semiBold"
          textColor={patientAccessTheme.palette.grey[700]}
          margin="2.5rem 1rem 1rem"
          align="left"
        >
          {pageTitle}
        </Typography>
      ) : (
        pageTitle
      )}
      <Grid className={classes.main}>{body}</Grid>
    </section>
  );
};

export default ReportsTemplate;
